// extracted by mini-css-extract-plugin
export default {"preChatImage":"DeprecatedOscPreChatHeader_preChatImage__SM814","container":"DeprecatedOscPreChatHeader_container__-VtT3"};